<template>
  <nav class="row">
    <ol class="breadcrumb arr-right">

      <!-- HOME -->
      <li class="breadcrumb-item">
        <router-link to="/dashboard">
          <i class="fa fa-home"></i>&nbsp;Dashboard
        </router-link>
      </li>

      <!-- DYNAMIC -->
      <li
        v-for="(item, index) in breadcrumbs"
        :key="index"
        class="breadcrumb-item"
        :class="{ active: isActive(item) }"
      >
        <!-- CLICKABLE -->
        <router-link
          v-if="!isActive(item)"
          :to="item.path"
        >
          {{ item.name }}
        </router-link>

        <!-- ACTIVE -->
        <span v-else>
          {{ item.name }}
        </span>
      </li>

    </ol>
  </nav>
</template>

<script>
/* eslint-disable */
export default {
  name: 'AppBreadcrumb',

  computed: {
    breadcrumbs() {
      var crumbs = this.$route.meta && this.$route.meta.breadcrumbs

      if (!Array.isArray(crumbs)) return []

      return crumbs
    }
  },

 methods: {
  isActive(item) {
    const current = this.$route.path

    if (current === item.path) return true

    // dynamic routes only (naay :)
    if (this.$route.matched.some(r => r.path.includes(':'))) {
      return current.startsWith(item.path + '/')
    }

    return false
  }
}
}
</script>


// WEBPACK FOOTER //
// src/components/core/Breadcrumbs.vue